import { useState } from 'react';

import { Trash2Icon } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { FieldsetCard } from '@/components/atoms/FieldsetCard/FieldsetCard';
import { SectionLayout } from '@/components/atoms/SectionLayout/SectionLayout';
import { MODAL_DELETE } from '@/components/organisms/Modals/ModalConductor';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useAccount } from '@/hooks/useAccount';
import { pushModal } from '@/redux/modals/actions';

const AccountDelete = () => {
  const { t } = useTranslation();
  const { account, deleteAccount, deleteStatus } = useAccount();
  const dispatch = useDispatch();
  const [confirmed, setConfirmed] = useState(false);

  const handleDeleteClick = () => {
    const deleteProps = {
      subtitle: <Trans i18nKey="accounts.delete_subtitle" values={[account?.name]} />,
      title: t('accounts.delete'),
      confirm: true,
      forceEnablePrimaryButton: true,
      onDelete: () => {
        deleteAccount(null);
      },
    };
    dispatch(pushModal(MODAL_DELETE, deleteProps));
  };

  return (
    <SectionLayout title={t('accounts.delete')}>
      <FieldsetCard>
        <Label className="flex cursor-pointer items-start gap-3">
          <Checkbox
            className="mt-0.5"
            checked={confirmed}
            onCheckedChange={(checked) => setConfirmed(checked === true)}
          />
          <span>
            <span className="block text-sm leading-5 font-medium text-foreground">
              {t('accounts.delete_confirm')}
            </span>
            <span className="block text-sm leading-5 text-muted-foreground">
              {t('accounts.delete_queue_data')}
            </span>
          </span>
        </Label>
      </FieldsetCard>
      <div>
        <Button
          variant="destructive-ghost"
          disabled={!confirmed}
          isLoading={deleteStatus === 'pending'}
          onClick={handleDeleteClick}
        >
          <Trash2Icon size={16} />
          {t('accounts.delete')}
        </Button>
      </div>
    </SectionLayout>
  );
};

export default AccountDelete;
